<template>
  <v-btn
    v-bind="activatorProps"
    :icon="iconName"
    size="30"
    :text="title"
    class="ma-1"
    variant="outlined"
    @click="isActive = true"
  ></v-btn>
  <v-dialog max-width="600" v-model="isActive">
    <v-card :title="title">
      <v-div id="printArea">
        <v-sheet id="printArea1" dir="rtl" class="mx-auto" width="300">
          <h1>إيصال دفع</h1>
          <p>
            <span class="label">رقم الإيصال</span> : <span>{{ item.id }}</span>
          </p>
          <p>
            <span class="label">السيد</span> :
            <span>{{ item.customer.name }}</span>
          </p>
          <p>
            <span class="label">القيمة المدفوعة</span> :
            <span>{{ item.value }}</span
            ><span class="currency">ل.س</span>
          </p>
          <p>
            <span class="label">الخصم الكلي</span> :
            <span>{{ item.totalDiscount }}</span
            ><span class="currency">ل.س</span>
          </p>
          <p>
            <span class="label"> الرصيد السابق</span> :
            <span>{{ item.old_balance }}</span>
          </p>
          <p>
            <span class="label"> الرصيد الحالي</span> :
            <span>{{ item.current_balance }}</span>
          </p>
          <p>
            <span class="label">تاريخ الإيصال</span> :
            <span>{{ item.actionDate }}</span>
          </p>
          <p>
            <span class="label">رقم العداد</span> :
            <span>{{ item.customer.meters[0].code }}</span>
          </p>
          <p>
            <span class="label"> العلبة</span> :
            <span>{{ item.customer.meters[0].parent.name }}</span>
          </p>
          <p>
            <span class="label">آخر قراءة</span> :
            <span>{{ item.last_reading }}</span>
          </p>
          <p>
            <span class="label">القراءة السابقة</span> :
            <span>{{ item.last_paid }}</span>
          </p>
          <!-- <p>
            <span class="label">آخر قراءة</span> :
            <span>{{
              item.customer.meters[0].readings[
                item.customer.meters[0].readings?.length - 1
              ]?.current_value
            }}</span>
          </p>
          <p>
            <span class="label">القراءة السابقة</span> :
            <span>{{
              item.customer.meters[0].readings[
                item.customer.meters[0].readings?.length - 2
              ]?.current_value
            }}</span>
          </p> -->
          <p>
            <span class="label">المحاسب</span> :
            <span>{{ item.accountant.fullname }}</span>
          </p>
          <!-- <br />
          <br />
          <p class="signature">الخاتم والتوقيع</p>
          <br />
          <br /> -->
        </v-sheet>
      </v-div>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn text="طباعة" @click="print"></v-btn>
        <v-btn text="إغلاق" @click="close"></v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: ["item", "iconName"],
  data() {
    return {
      isActive: false,
    };
  },
  methods: {
    print1() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
        <html>
          <head>
            <title>Print Content</title>
            <style>
              @media print {
                @page {
                  size: 72mm 210mm;
                  margin: 0; /* Remove margin for exact size */
                }
                body {
                  display: block;
                  justify-content: center;
                  align-items: center;
                  text-align:center;
                  margin: 0; /* Remove margins */
                  height: 100%; /* Ensure the body takes full height */
                  align-items: flex-start; /* Align items to the start to avoid extra space */
                  padding: 0; /* No padding */
                  font-size: 16px;
                  margin-top: -10px; /* Adjust this value as needed */
                }
              }
            </style>
          </head>
          <body>
            ${printContent}
          </body>
        </html>
      `);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    print() {
      const printElement = document.getElementById("printArea");
      if (!printElement) {
        console.error("Element not found");
        return;
      }

      const printContent = printElement.innerHTML;
      const printWindow = window.open("", "_blank", "width=800,height=600");

      printWindow.document.write(`
    <html>
      <head>
        <title>Print Content</title>
        <style>
          @media print {
            @page {
              size: 72mm 210mm;
              margin: 0; /* Remove margin for exact size */
            }
            body {
              display: block;
              justify-content: center;
              align-items: center;
              text-align: center;
              margin: 0; /* Remove margins */
              height: 100%; /* Ensure the body takes full height */
              padding: 0; /* No padding */
              font-size: 16px;
              page-break-after: avoid; /* Avoid page breaks after this content */
            }
            /* Prevent headers/footers from being printed */
            header, footer {
              display: none; /* Hide headers/footers if they exist */
            }
          }
        </style>
      </head>
      <body>
        ${printContent}
      </body>
    </html>
`);

      printWindow.document.close();
      printWindow.focus();
      printWindow.print();
      printWindow.close();
    },

    close() {
      this.isActive = false;
    },
  },
};
</script>

<style scoped>
.currency {
  margin: 3px;
}
.label {
  margin: 3px;
  font-weight: bold;
}
.signature {
  margin: 10px auto;
  font-weight: bold;
}
</style>
